import React, { useCallback } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import { useHistory } from 'react-router-dom'
import { BlurText } from '../../components'
import useStore from '../../store'
import './Info.css'

const Info = () => {
  const history = useHistory()
  const playByName = useStore((state) => state.playByName)

  const onGoBack = useCallback(() => {
    playByName('Info', 'click')
    history.goBack()
  }, [history, playByName])

  return (
    <div className="g-info" onClick={onGoBack}>
      <Scrollbars className="g-scroll g-info-scroll">
        <div>
          <BlurText active>Luz penetrante. Derramamento divino universos afora, universos adentro. Do drama cósmico das esferas às carcaças metálicas dos detritos espaciais e dos carros rasgando as cidades. Das rotações dos astros às aparições de faróis, postes e neons. Acendem também as florestas remanescentes e os mananciais refletindo o Sol. Mais à noite, qualquer viela pouco iluminada guarda em si o enigma denso e excruciante de se viver na era da grande massa antropogênica, maior que o acúmulo de todos os seres vivos, e que dobra de tamanho a cada 20 anos. Trilhões de toneladas nos cercando por todos os lados; objeto escultórico massivo erguido por nossas mãos, impregnado de nossos artifícios… Sem nunca soterrar o presente, a nova natureza come solta: soltam-se os ruídos inflexíveis da construção civil e o ronco dos motores. Irrompem os estalos de escapamento e o alvorecer das aparelhagens e paredões. Nas esquinas, afiam-se as sugestões; e de repente: despontam os sussurros lascivos nas portas das boates. Na outra extremidade do espectro: emanam dos santos, desde muito e até sempre, os mantras fundamentais. Segue-se o tino da criação. Harmonia, movimento, estagnação. Ou a definitiva ascensão. Daqui até o bater do bumbo que chamará tudo de volta. Tudo a Si, ao OM onisciente. O verbo como imagem e intelecto. Convocando-nos ao nada, até podermos ser novamente.</BlurText>
        </div>

        <div>
          <BlurText active><span className="eng-txt">Penetrating light. Divine outpouring of universes, to and fro. From the cosmic drama of the spheres to the metallic carcasses of space debris and cars tearing through cities. From the rotation of the stars to the appearance of headlights, lampposts and neon lights. The remnants of forests and springs also light up as they reflect the sun. At night, any dimly lit alley keeps in its interior the dense and excruciating enigma of living in the era of the great anthropogenic mass, greater than the accumulation of all living beings, which doubles in size every 20 years. Trillions of tons of stuff surrounding us on all sides; a massive sculptural object raised by our hands, impregnated with our artifices... Without ever burying the present, the new nature is full on: the inflexible noises of civil construction and the roar of engines are released. Exhaust pipes crackle and  the dawn of aparelhagem and its enormous sound walls. In the corners, the suggestions are sharpened; and suddenly: lustful whispers emerge around the nightclubs’ doors. At the other extremity of the spectrum: the fundamental mantras emanate from the saints, since long ago and forever. The tint of creation goes on. Harmony, movement, stagnation. Or the definitive rise. From here until the beat of the drums that will call everything back. Back in, to the omniscient OM. The verb as image and intellect. Calling us to nothing, until we can be again.</span></BlurText>
        </div>

        <div>
          <BlurText active>Genesys→2021</BlurText>
          <BlurText active>Evento online de energia sonora/<span className="eng-txt">Online sound energy event</span></BlurText>
        </div>

        <div>
          <BlurText active>Uma jornada com/<span className="eng-txt">A journey with</span></BlurText>
          <BlurText active>DIAZ</BlurText>
          <BlurText active>MEXA</BlurText>
          <BlurText active>Miss Tacacá</BlurText>
          <BlurText active>ótimoKaráter</BlurText>
          <BlurText active>Podeserdesligado</BlurText>
          <BlurText active>XIAO QUAN</BlurText>
        </div>

        <div>
          <BlurText active>Concepção/<span className="eng-txt">Conception</span></BlurText>
          <BlurText active>Germano Dushá</BlurText>
          <BlurText active>Raul Luna</BlurText>
          <BlurText active>Marcelo Mudou</BlurText>
        </div>

        <div>
          <BlurText active>Curadoria e texto/<span className="eng-txt">Curated & text by</span></BlurText>
          <BlurText active>Germano Dushá</BlurText>
        </div>

        <div>
          <BlurText active>Design gráfico e interface/<span className="eng-txt">Graphic design & interface</span></BlurText>
          <BlurText active>Raul Luna</BlurText>
        </div>

        <div>
          <BlurText active>Programação/<span className="eng-txt">Code</span></BlurText>
          <BlurText active>Guilherme Gallo</BlurText>
        </div>

        <div>
          <BlurText active>Desenho de som/<span className="eng-txt">Sound design</span></BlurText>
          <BlurText active>Marcelo Mudou</BlurText>
        </div>

        <div>
          <BlurText active>Produção/<span className="eng-txt">Production</span></BlurText>
          <BlurText active>Fabricia Ramos</BlurText>
        </div>

        <div>
          <BlurText active>Produção musical/<span className="eng-txt">Music production "Mexa - Especial Fim de Ano"</span></BlurText>
          <BlurText active>José Hesse</BlurText>
        </div>

        <div>
          <BlurText active>Tradução/<span className="eng-txt">Translation</span></BlurText>
          <BlurText active>Vinicius Duarte</BlurText>
        </div>

        <div>
          <BlurText active>Crédito das fotos/<span className="eng-txt">Photo credits</span></BlurText>
          <BlurText active>DIAZ: Hick Duarte</BlurText>
          <BlurText active>Miss Tacacá: Leo Fagherazzi</BlurText>
          <BlurText active>ótimoKaráter: Alexandre Furcolin Filho</BlurText>
          <BlurText active>Podeserdesligado: Lucas Pietro</BlurText>
          <BlurText active>XIAO QUAN: Ivi Maiga Bugrimenko</BlurText>
        </div>

        <div className="g-info-banner">
          <BlurText active>Realização/<span className="eng-txt">Produced by</span></BlurText>
          <img id="g-info-sesc" alt="SESC" src="/assets/images/info/Sesc Logo.png" />
          <BlurText active>Um projeto/<span className="eng-txt">A project by</span></BlurText>
          <img className="g-logo" alt="Genesys" src="/assets/images/info/Genesys Logo.png" />
        </div>

        <div>
          <BlurText active>Genesys→2021</BlurText>
          <BlurText active>genesys.life</BlurText>
          <BlurText active>2021</BlurText>
        </div>
      </Scrollbars>
    </div>
  )
}

export default Info
